import { collection, onSnapshot } from "firebase/firestore";
import { firestore } from "../../../configs/FirebaseConfig";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_INVITED_USERS_TABLE } from "../../../constants/FirestoreConstant";

export function useInvitedUsers() {
  const { data, error } = useSWRSubscription("invitedUsers", (key, { next }) => {
    const q = collection(firestore, FIRESTORE_INVITED_USERS_TABLE);

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        try {
          const invitedUsersData = snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
          next(null, invitedUsersData);
        } catch (err) {
          next(err, null);
        }
      },
      (error) => {
        next(error, null);
      },
    );

    return () => {
      unsubscribe();
    };
  });

  return {
    data,
    error,
    loading: !data && !error,
  };
}
